import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const DeliveryIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.75098 5H12.249C12.9537 5.00003 13.5564 5.48904 13.7109 6.16406L13.7354 6.30176L14.2021 9.80176C14.322 10.7009 13.6229 11.4999 12.7158 11.5H2.28418C1.4337 11.4999 0.765423 10.7975 0.78418 9.96875L0.797852 9.80176L1.26465 6.30176C1.36403 5.5566 1.99922 5.00003 2.75098 5Z"
        stroke={color ?? 'current-color'}
      />
      <path
        d="M11.5 5.5L11.1977 2.77914C11.0851 1.76627 10.229 1 9.20991 1H5.79009C4.77099 1 3.91486 1.76627 3.80232 2.77914L3.5 5.5"
        stroke={color ?? 'current-color'}
      />
      <path d="M3 11.5L3 13" stroke={color ?? 'current-color'} strokeLinecap="round" />
      <path d="M12 11.5L12 13" stroke={color ?? 'current-color'} strokeLinecap="round" />
      <circle cx="4" cy="8.5" r="1" stroke={color ?? 'current-color'} />
      <circle cx="11.5" cy="8.5" r="1" stroke={color ?? 'current-color'} />
      <path d="M6.5 8.5H9" stroke={color ?? 'current-color'} strokeLinecap="round" />
    </svg>
  );
};

export default DeliveryIcon;
